import { render, staticRenderFns } from "./AuthUserPdfViewer.component.vue?vue&type=template&id=bddd1a88"
import script from "./AuthUserPdfViewer.component.vue?vue&type=script&lang=js"
export * from "./AuthUserPdfViewer.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports